import React from 'react';
import './References.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWaveSquare } from '@fortawesome/free-solid-svg-icons';
import ReferenceSlider from '../ReferenceSlider/ReferenceSlider';

const iconOne = <FontAwesomeIcon icon={faWaveSquare} />

const References = () => {

    return (
        <div className = "container-fluid">
            <div className = "row">
                <div className = "col-xs-12 col-md-4">
                    <div className = "row">
                        <ReferenceSlider />
                    </div>
                </div>
                <div className = "col-xs-12 col-md-8 references-background d-flex justify-content-center align-items-center">
                    <div className = "reference-content p-5">
                        <h2 className = "reference-title text-uppercase text-white">Reference</h2>
                        <div className = "row">
                            <div className = "col-md-6">
                                <ul className = "p-0">
                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada fekalne kanalizacije za Objekat Phoenix u Šimanovcima.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija za Objekat namenske industrije u Uzićima.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija za Objekat namenske industrije u Velikoj Plani.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija za Objekat Porodilište “Narodni front” u Beogradu.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija za Objekat trafo stanice u Srbobranu.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija za Objekat Ortopedska bolnica u Beogradu.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija za maloprodajni Objekat Lidl na Vidikovcu.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija za Objekat namenske industrije - Krušik Valjevo.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija za Objekat benziske stanice NIS u Petrovcu na Mlavi.
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                            <div className = "col-md-6">
                                <ul className = "p-0">
                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija za Objekat javne garaže Pionirski park u Beogradu.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija za Objekat javne garaže Obilićev venac u Beogradu.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrantske mreže DN250 mm u krugu Rafinerije nafte i Skladišta NIS Novi Sad.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija za Objekat Centralne parne kotlarnice i Parne kotlarnice za otpadne vode u krugu Rafinerije nafte i Skladišta NIS Novi Sad.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija za Objekat Parne kotlarnice u Senti.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija za Objekat VMA u Beogradu.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija za auto salon i servis “Ćirinac” u Beogradu.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija na sanitarnoj deponiji u Kikindi.
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className = "row">
                                            <div className = "col-md-1">
                                                {iconOne}
                                            </div>
                                            <div className = "col-md-11">
                                                Izrada hidrotehničkih instalacija za maloprodajni Objekat Lidl u Zemunskoj ulici u Beogradu.
                                            </div>
                                        </div>
                                    </li>
                                
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default References;